<template>
    <div class="graficas" v-loading="loading">

        <template v-if="visible">
            
            <el-card class="box-card" v-if="spline" shadow="never">
                <div slot="header" class="clearfix">
                    <span>Ventas</span>
                </div>
                <apexchart type="area" width="100%" height="200px" :options="spline.chartOptions" :series="spline.series"></apexchart>
            </el-card>

            <el-card class="box-card" v-if="bar" shadow="never">
                <div slot="header" class="clearfix">
                    <span>Clientes</span>
                </div>
                <apexchart width="100%" type="bar" :options="bar.options" :series="bar.series"></apexchart>
            </el-card>
        </template>
        

    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'

	export default {
        name: 'Graficas',
        props: {
            visible: {
                type: Boolean,
                default: () => false
            }
        },
        components: {
            'apexchart': VueApexCharts
        },
        data(){
            return {
                error: null,
                loading: false,
                bar: {
                    options: {
                        chart: {
                        id: 'vuechart-example'
                        },
                        xaxis: {
                        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
                        }
                    },
                    series: [{
                        name: 'series-1',
                        data: [30, 40, 45, 50, 49, 60, 70, 91]
                    }]
                },
                spline: {
                   series: [{
                        name: 'series1',
                        data: [31, 40, 28, 51, 42, 109, 100]
                    }, {
                        name: 'series2',
                        data: [11, 32, 45, 32, 34, 52, 41]
                    }],
                    chartOptions: {
                        chart: {
                        height: 350,
                        type: 'area'
                        },
                        dataLabels: {
                        enabled: false
                        },
                        stroke: {
                        curve: 'smooth'
                        },
                        xaxis: {
                        type: 'datetime',
                        categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
                        },
                        tooltip: {
                        x: {
                            format: 'dd/MM/yy HH:mm'
                        },
                        },
                    },
                } 
                
            }
        },
        watch: {
            visible() {
                if (!this.visible) return
                this.getData()
            }
        },
        mounted() { this.$emit('created') },
        methods: {
            async getData() {

                this.loading = true

                setTimeout(() => {
                    
                    try {

                        //resp = await getDocumentos()
                    } catch(e) {
                        this.error = e
                    }

                    this.loading = false
                }, 500)
            }
        }
	}
</script>

<style lang="scss" scope>
.graficas {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    .box-card {
        margin-bottom: 5px;
        .el-card__body {
            padding: 10px 0px;
        }
    }
}
</style>